import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setSecurityLevel: {
		id: 'issue-field-security-level.security-level-view.dropdown.set-security-level',
		defaultMessage: 'Set security level',
		description: 'Menu Heading - Shown when prompting the user to se a security level for an issue',
	},
});
